import React from 'react';
import type {
  ModuleEnum,
  TaskDefinitionSimpleResponse,
  TaskTypeEnum} from 'src/api/ProactApiClient';
import {
  PermissionOperationEnum,
  TaskDefinitionStateEnum
} from 'src/api/ProactApiClient';
import {taskDocumentTitle} from 'src/app/tasks/taskHelpers';
import {useHasModulePermission} from 'src/shared/auth/useHasModulePermission';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {TaskDefinitionTable} from 'src/app/tasks/TaskDefinitionTable/TaskDefinitionTable';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface ListTaskDefinitionsProps {
  taskType: TaskTypeEnum;
  module: ModuleEnum;
}

export const ListTaskDefinitions: React.FC<ListTaskDefinitionsProps> = ({
  taskType,
  module,
}) => {
  useSetDocumentTitle(taskDocumentTitle);

  const navigate = useAppNavigate();

  const {hasPermission: hasCreatePermission} = useHasModulePermission({
    module: module,
    operation: PermissionOperationEnum.Create,
  });

  const handleAddNew = () => navigate(PathUtility.TaskCreate(taskType));

  const handleViewClick = (row: TaskDefinitionSimpleResponse) =>
    navigate(PathUtility.TaskView(taskType, row.id, 'content'));

  return (
    <>
      <TaskDefinitionTable
        identifier={`task-${taskType}-definition-table`}
        taskType={taskType}
        defaultSorting={[{id: 'dueAt', desc: false}]}
        defaultColumnFilters={[
          {
            id: 'state',
            value: [
              TaskDefinitionStateEnum.Draft.toString(),
              TaskDefinitionStateEnum.Published.toString(),
            ],
          },
        ]}
        onCreate={hasCreatePermission ? handleAddNew : undefined}
        onViewRowClick={handleViewClick}
      />
    </>
  );
};
